<template>
  <div style="display: flex;">
    <div style="padding: 0 20px;min-width: 350px;max-width: 350px;">
      <!-- 说明 -->
      <div class="phone-type-select">
        <div :class="backgroundPhoneType == 2?'selected' :''" @click="backgroundPhoneType = 2">iOS</div>
        <div :class="backgroundPhoneType == 3?'selected' :''" @click="backgroundPhoneType = 3">Android</div>
      </div>
      <div class="image-type-select">
        <div :class="backgroundType == 1?'selected' :''" @click="backgroundType = 1">{{$I18n("sig_img")}}</div>
        <div :class="backgroundType == 2?'selected' :''" @click="backgroundType = 2">{{$I18n("mult_img")}}</div>
      </div>
      <div v-if="backgroundPhoneType == 2">
        <div v-if="backgroundType == 1">
          <p class="image-name">{{$I18n("full_img")}}</p>
          <p class="image-info">{{$I18n("image_require_w_h_size").replace("%a%", '1284').replace("%b%", '2788').replace("%c%", '1MB')}}</p>
          <!-- 添加图片 -->
          <div style="position:relative;">
            <div @click="clickInput('file_input_i_1')" class="icon-image-select-box-three">
              <!-- 重置 -->
              <div class="reset-icon" @click.stop="resetBackImage(imageTypeList[0])">
                <md-icon style="color: rgba(255,255,255, .9);">restart_alt</md-icon>
              </div>
              <!-- 上传图片提示 -->
              <div v-if="!isuploadimage && mouseMove" class="image-box-info" :class="i_f_img == '' ? '' :'hidden-mode'">
                <div class="button">{{$I18n("upload_img")}}</div>
              </div>
              <!-- 图片 -->
              <div v-if="i_f_img" class="img">
                <img :src="i_f_img"/>
              </div>
              <!-- 无图背景 -->
              <div v-else class="none-img-background"></div>
            </div>
            <!-- uploading 旋转图标 -->
            <div v-if="isuploadimage && uploadType == 0" class="loading loading-container" >
              <div>
                <i class="iconfont load-icon-small" :style="{transform: `rotate(${rotatedeg}deg)`}">&#xe61e;</i>
              </div>
            </div>
          </div>
        </div>
        <div v-if="backgroundType == 2">
          <p class="image-name">{{$I18n("back_img")}}</p>
          <p class="image-info">{{$I18n("image_require_w_h_size").replace("%a%", '1284').replace("%b%", '2788').replace("%c%", '1MB')}}</p>
          <!-- 添加图片 -->
          <div style="position:relative;">
            <div @click="clickInput('file_input_i_2')" class="icon-image-select-box-three">
              <!-- 重置 -->
              <div class="reset-icon" @click.stop="resetBackImage(imageTypeList[1])">
                <md-icon style="color: rgba(255,255,255, .9);">restart_alt</md-icon>
              </div>
              <!-- 上传图片提示 -->
              <div v-if="!isuploadimage && mouseMove" class="image-box-info" :class="i_b_img == '' ? '' :'hidden-mode'">
                <div class="button">{{$I18n("upload_img")}}</div>
              </div>
              <!-- 图片 -->
              <div v-if="i_b_img" class="img">
                <img :src="i_b_img"/>
              </div>
              <!-- 无图背景 -->
              <div v-else class="none-img-background"></div>
            </div>
            <!-- uploading 旋转图标 -->
            <div v-if="isuploadimage && uploadType == 1" class="loading loading-container" >
              <div>
                <i class="iconfont load-icon-small" :style="{transform: `rotate(${rotatedeg}deg)`}">&#xe61e;</i>
              </div>
            </div>
          </div>
          <p class="image-name">{{$I18n("spl_screen_logo")}}</p>
          <p class="image-info">{{$I18n("image_require_w_h_size").replace("%a%", '360').replace("%b%", '360').replace("%c%", '1MB')}}</p>
          <div style="position:relative;">
            <div @click="clickInput('file_input_i_3')" class="icon-image-select-box-three">
              <!-- 重置 -->
              <div class="reset-icon" @click.stop="resetBackImage(imageTypeList[2])">
                <md-icon style="color: rgba(255,255,255, .9);">restart_alt</md-icon>
              </div>
              <!-- 上传图片提示 -->
              <div v-if="!isuploadimage && mouseMove" class="image-box-info" :class="i_i_img == '' ? '' :'hidden-mode'">
                <div class="button">{{$I18n("upload_img")}}</div>
              </div>
              <!-- 图片 -->
              <div v-if="i_i_img" class="img">
                <img :src="i_i_img"/>
              </div>
              <!-- 无图背景 -->
              <div v-else class="none-img-background"></div>
            </div>
            <!-- uploading 旋转图标 -->
            <div v-if="isuploadimage && uploadType == 2" class="loading loading-container" >
              <div>
                <i class="iconfont load-icon-small" :style="{transform: `rotate(${rotatedeg}deg)`}">&#xe61e;</i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="backgroundPhoneType == 3">
        <div v-if="backgroundType == 1">
          <p class="image-name">{{$I18n("full_img")}}</p>
          <p class="image-info">{{$I18n("image_require_w_h_size").replace("%a%", '1080').replace("%b%", '1920').replace("%c%", '1MB')}}</p>
          <!-- 添加图片 -->
          <div style="position:relative;">
            <div @click="clickInput('file_input_a_1_s')" class="icon-image-select-box-three">
              <!-- 重置 -->
              <div class="reset-icon" @click.stop="resetBackImage(imageTypeList[3])">
                <md-icon style="color: rgba(255,255,255, .9);">restart_alt</md-icon>
              </div>
              <!-- 上传图片提示 -->
              <div v-if="!isuploadimage && mouseMove" class="image-box-info" :class="a_f_img_s == '' ? '' :'hidden-mode'">
                <div class="button">{{$I18n("upload_img")}}</div>
              </div>
              <!-- 图片 -->
              <div v-if="a_f_img_s" class="img">
                <img :src="a_f_img_s"/>
              </div>
              <!-- 无图背景 -->
              <div v-else class="none-img-background"></div>
            </div>
            <!-- uploading 旋转图标 -->
            <div v-if="isuploadimage && uploadType == 3" class="loading loading-container" >
              <div>
                <i class="iconfont load-icon-small" :style="{transform: `rotate(${rotatedeg}deg)`}">&#xe61e;</i>
              </div>
            </div>
          </div>
          <p class="image-info">{{$I18n("image_require_w_h_size").replace("%a%", '1080').replace("%b%", '2160').replace("%c%", '1MB')}}</p>
          <!-- 添加图片 -->
          <div style="position:relative;">
            <div @click="clickInput('file_input_a_1_l')" class="icon-image-select-box-three">
              <!-- 重置 -->
              <div class="reset-icon" @click.stop="resetBackImage(imageTypeList[4])">
                <md-icon style="color: rgba(255,255,255, .9);">restart_alt</md-icon>
              </div>
              <!-- 上传图片提示 -->
              <div v-if="!isuploadimage && mouseMove" class="image-box-info" :class="a_f_img_l == '' ? '' :'hidden-mode'">
                <div class="button">{{$I18n("upload_img")}}</div>
              </div>
              <!-- 图片 -->
              <div v-if="a_f_img_l" class="img">
                <img :src="a_f_img_l"/>
              </div>
              <!-- 无图背景 -->
              <div v-else class="none-img-background"></div>
            </div>
            <!-- uploading 旋转图标 -->
            <div v-if="isuploadimage && uploadType == 4" class="loading loading-container" >
              <div>
                <i class="iconfont load-icon-small" :style="{transform: `rotate(${rotatedeg}deg)`}">&#xe61e;</i>
              </div>
            </div>
          </div>
        </div>
        <div v-if="backgroundType == 2">
          <p class="image-name">{{$I18n("back_img")}}</p>
          <p class="image-info">{{$I18n("image_require_w_h_size").replace("%a%", '1080').replace("%b%", '1920').replace("%c%", '1MB')}}</p>
          <!-- 添加图片 -->
          <div style="position:relative;">
            <div @click="clickInput('file_input_a_2')" class="icon-image-select-box-three">
              <!-- 重置 -->
              <div class="reset-icon" @click.stop="resetBackImage(imageTypeList[5])">
                <md-icon style="color: rgba(255,255,255, .9);">restart_alt</md-icon>
              </div>
              <!-- 上传图片提示 -->
              <div v-if="!isuploadimage && mouseMove" class="image-box-info" :class="a_b_img == '' ? '' :'hidden-mode'">
                <div class="button">{{$I18n("upload_img")}}</div>
              </div>
              <!-- 图片 -->
              <div v-if="a_b_img" class="img">
                <img :src="a_b_img"/>
              </div>
              <!-- 无图背景 -->
              <div v-else class="none-img-background"></div>
            </div>
            <!-- uploading 旋转图标 -->
            <div v-if="isuploadimage && uploadType == 5" class="loading loading-container" >
              <div>
                <i class="iconfont load-icon-small" :style="{transform: `rotate(${rotatedeg}deg)`}">&#xe61e;</i>
              </div>
            </div>
          </div>
          <p class="image-name">{{$I18n("spl_screen_logo")}}</p>
          <p class="image-info">{{$I18n("image_require_w_h_size").replace("%a%", '344').replace("%b%", '344').replace("%c%", '1MB')}}</p>
          <div style="position:relative;">
            <div @click="clickInput('file_input_a_3')" class="icon-image-select-box-three">
              <!-- 重置 -->
              <div class="reset-icon" @click.stop="resetBackImage(imageTypeList[6])">
                <md-icon style="color: rgba(255,255,255, .9);">restart_alt</md-icon>
              </div>
              <!-- 上传图片提示 -->
              <div v-if="!isuploadimage && mouseMove" class="image-box-info" :class="a_i_img == '' ? '' :'hidden-mode'">
                <div class="button">{{$I18n("upload_img")}}</div>
              </div>
              <!-- 图片 -->
              <div v-if="a_i_img" class="img">
                <img :src="a_i_img"/>
              </div>
              <!-- 无图背景 -->
              <div v-else class="none-img-background"></div>
            </div>
            <!-- uploading 旋转图标 -->
            <div v-if="isuploadimage && uploadType == 6" class="loading loading-container" >
              <div>
                <i class="iconfont load-icon-small" :style="{transform: `rotate(${rotatedeg}deg)`}">&#xe61e;</i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <input v-for="(item, index) in imageTypeList" :ref="item.ref" @change="e => onFileChange(e, item)" :key="index + 'upload_img_input'" type="file" style="display:none;" />
    </div>
    <!-- 图片展示 -->
    <div style="flex:1;text-align: center;">
      <phone-three :background_src="i_f_img" :background_high_src="i_f_img" v-if="backgroundPhoneType == 2 && backgroundType == 1" />
      <phone-three :icon_src="i_i_img" :background_src="i_b_img" :background_high_src="i_b_img" v-if="backgroundPhoneType == 2 && backgroundType == 2"/>
      <phone-three :background_src="a_f_img_s" :background_high_src="a_f_img_l" v-if="backgroundPhoneType == 3 && backgroundType == 1"/>
      <phone-three :icon_src="a_i_img" :background_src="a_b_img" :background_high_src="a_b_img" v-if="backgroundPhoneType == 3 && backgroundType == 2"/>
      <div style="text-align: center;">
        {{$I18n("import_info_03")}}
      </div>
    </div>
  </div>
</template>
<script>
import PhoneThree from './PhoneThree.vue';
// import ImageCropper from '@/components/Common/ImageCropper.vue'
export default {
  name: "res-mng",
  components: { PhoneThree },
  props: {
    app_id : {
      type: Number,
      default: 0,
    },
  },
  data(){

    // type : 1/2/3 
    const imageTypeList = [
      // iOS
      {index: 0, type: 1, width: 1284 ,high: 2788 , phone: 2, ref: "file_input_i_1"},
      {index: 1, type: 2, width: 1284 ,high: 2788 , phone: 2, ref: "file_input_i_2"},
      {index: 2, type: 3, width: 360  ,high: 360  , phone: 2, ref: "file_input_i_3"},
      // 安卓
      {index: 3, type: 1, width: 1080 ,high: 1920 , phone: 3, ref: "file_input_a_1_s"},
      {index: 4, type: 1, width: 1080 ,high: 2160 , phone: 3, ref: "file_input_a_1_l"},
      {index: 5, type: 2, width: 1080 ,high: 1920 , phone: 3, ref: "file_input_a_2"},
      {index: 6, type: 3, width: 344  ,high: 344  , phone: 3, ref: "file_input_a_3"},
    ]
    return {
      imageTypeList,
      isuploadimage: false,   // 是否正在上传图片
      mouseMove: true,        // 鼠标重新移动了
      intervalUploadImage: 0, // 定时器 Interval
      rotatedeg: 0, // loarding角度

      uploadType:0, // 正在更新的uploadType

      backgroundPhoneType:2, // 2: IOS 3: 安卓
      backgroundType:1, // 1: 单图 2: 多图
      appImgBackground_i: {
        state: 1,
        urls : [],
      },
      appImgBackground_a: {
        state: 1,
        urls : [],
      },
    }
  },
  mounted(){
    this.api_getUrl()
      .then(() => {
        if(!this.appImgBackground_i.id){
          return this.$api.addAppImgUrl({
            master_id: this.app_id,
            state    : 1,
            key      : "launch",
            urls     : [],
            client_type: 2,
          })
            .then(() => {
              if(!this.appImgBackground_a.id){
                return this.$api.addAppImgUrl({
                  master_id: this.app_id,
                  state    : 1,
                  key      : "launch",
                  urls     : [],
                  client_type: 3,
                })
              }
            })
            .then(() => {
              this.api_getUrl();
            })
        } else if(!this.appImgBackground_a.id){
          return this.$api.addAppImgUrl({
            master_id: this.app_id,
            state    : 1,
            key      : "launch",
            urls     : [],
            client_type: 3,
          })
            .then(() => {
              this.api_getUrl();
            })
        }
      })
      .then(() => {
        if(this.i_b_img && !this.i_f_img){
          this.backgroundType = 2;
        } else {
          this.backgroundType = 1;
        }
      })
    document.addEventListener('mousemove', this.handleMouseMove);
  },
  beforeDestroy(){
    document.removeEventListener('mousemove', this.handleMouseMove);
    clearInterval(this.intervalUploadImage)
  },
  watch:{
    backgroundPhoneType(newValue){
      if(newValue == 2){
        if(this.i_b_img && !this.i_f_img){
          this.backgroundType = 2;
        } else {
          this.backgroundType = 1;
        }
      } else if(newValue == 3){
        if(this.a_b_img && !this.a_f_img_s && !this.a_f_img_l){
          this.backgroundType = 2;
        } else {
          this.backgroundType = 1;
        }
      }
    },
    // 启动、关闭 loading 转圈
    isuploadimage(newValue){
      if(newValue){
        this.intervalUploadImage = setInterval(() => {
          this.rotatedeg = this.rotatedeg + 10;
          if(this.rotatedeg > 360){
            this.rotatedeg = this.rotatedeg - 360
          }
        } , 30)
      } else {
        clearInterval(this.intervalUploadImage);
        this.rotatedeg = 0;
      }
    },
  },
  methods:{
    // 重置|删除特定图片
    resetBackImage(item){
      var sendData = {};
      var paramStr = JSON.stringify({
        type: item.type,
        size: item.width + "*" + item.high,
      });
      if(this.backgroundPhoneType == 2){// ios
        sendData = {
          ...this.appImgBackground_i,
          urls: this.appImgBackground_i.urls.filter(i => i.param != paramStr),
        }
      } else { // android
        sendData = {
          ...this.appImgBackground_a,
          urls: this.appImgBackground_a.urls.filter(i => i.param != paramStr),
        }
      }
      return this.$api.setAppImgUrl(sendData)
        .then(this.$Then(() => {
          this.api_getUrl();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    api_getUrl(){
      return this.$api.getAppImgUrl({ // api: /user/app/img/get
        master_id: this.app_id,
        key      : "launch",
      })
        .then(this.$Then(res => {
          if(res.data.length == 0){
            return
          }
          res.data.forEach(item => {
            if(item.client_type == 2){
              this.appImgBackground_i = this.getAppImgIcon(item)
            } else if(item.client_type == 3){
              this.appImgBackground_a = this.getAppImgIcon(item)
            }
          })
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    // 防止hover在上传文件后依旧存在
    handleMouseMove(){
      this.mouseMove = true;
    },
    // 上传ICON  type：1：整张，2：多图背景，3：多图LOGO size : 图片大小
    onFileChange(e, info) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files  || !files.length) return;
      let reader = new FileReader();

      var formData = new FormData();

      if(!files[0].type.includes("png")){
        // console.log(files[0].type, files[0].size)
        return 
      }
      this.checkImageSize(files[0], info.width, info.high, () => {
        this.isuploadimage = true;
        this.uploadType = info.index;
        this.mouseMove = false;
        formData.append('myfile', files[0]);
        this.$api.uploadFile(formData)
          .then(this.$Then(res => {
            reader.readAsDataURL(files[0]);
            // API 
            var sendData = {};
            var paramStr = JSON.stringify({
              type: info.type,
              size: info.width + "*" + info.high,
            });
            var newUrl = {
              lang: "en",
              param: paramStr,
              type: 1, 
              url: res.data,
            }
            if(this.backgroundPhoneType == 2){// ios
              sendData = {
                ...this.appImgBackground_i,
                urls: [newUrl, ...this.appImgBackground_i.urls.filter(i => i.param != paramStr)],
              }
            } else { // android
              sendData = {
                ...this.appImgBackground_a,
                urls: [newUrl, ...this.appImgBackground_a.urls.filter(i => i.param != paramStr)],
              }
            }
            // console.log(sendData, this.appImgBackground_i, this.appImgBackground_a)
            return this.$api.setAppImgUrl(sendData);
          }))
          .then(() => {
            this.api_getUrl();
          })
          .catch(this.$Catch(this.$I18n("get_error")))
          .then(() => {this.isuploadimage = false})
      }, () => {
        this.$errorMsg(this.$I18n("pls_corr_size"));
      })

    },
    // 确认图片大小是否符合要求
    checkImageSize(file,width,high,succ, fail){
      const img = new Image();
      const url = URL.createObjectURL(file);
      img.onload = () => {
        const img_width = img.width;
        const img_high = img.height;
        // console.log("图片宽度：", img_width);
        // console.log("图片高度：", img_high);

        // 释放内存
        URL.revokeObjectURL(url);
        // 判断是否等于 1000*500
        if (width === img_width && high === img_high && succ) {
          succ(file,width,high)
        } else if(fail) {
          fail(file,width,high)
        }
      };
      img.src = url;
    },
    // 点击 - 提交图片
    clickInput(refName){
      if(!refName){
        return
      }
      this.$refs[refName][0].click();
    },
    // 设置app_img_icon
    getAppImgIcon(data){
      return {
        ...data,
        urls : data.urls.map(item => {
          return {
            ...item,
            param_json : item.param ?JSON.parse(item.param) :{},
          }
        }),
      }
    },
    getImgByInfo(imgInfo){
      const paramStr= JSON.stringify({
        type: imgInfo.type,
        size: imgInfo.width + "*" + imgInfo.high,
      });
      const useObj = imgInfo.phone == 2 ?"appImgBackground_i" :"appImgBackground_a"
      const imgUrl  = this[useObj].urls.filter(i => i.param == paramStr)[0];
      return imgUrl ?imgUrl.url :""
    },
  },
  computed:{
    // 手机类型_图片类型_img_s/l(大小)
    i_f_img(){
      return this.getImgByInfo(this.imageTypeList[0])
    },
    i_b_img(){
      return this.getImgByInfo(this.imageTypeList[1])
    },
    i_i_img(){
      return this.getImgByInfo(this.imageTypeList[2])
    },
    a_f_img_s(){
      return this.getImgByInfo(this.imageTypeList[3])
    },
    a_f_img_l(){
      return this.getImgByInfo(this.imageTypeList[4])
    },
    a_b_img(){
      return this.getImgByInfo(this.imageTypeList[5])
    },
    a_i_img(){
      return this.getImgByInfo(this.imageTypeList[6])
    },
  },
}
</script>
<style scoped>
  .sec .menu-item-box{
    height: 60px; 
    padding: 8px 12px;
    display: flex;
    margin-right: 8px;
  }
  .menu-item-box{
    font-size: 14px;
    height: 40px;
    margin: 6px 0;
    box-sizing: border-box;
    padding: 4px 12px;
    line-height: 32px;
    cursor: pointer;
    border-radius: 4px;
    transition: background .2s;
  }
  .menu-item-box.selected{
    background: #00bcd4;
    color: #ffffff;
  }
  .menu-item-box:hover{
    background: #f4f4f4;
  }
  .menu-item-box.selected:hover{
    background: #00bcd4;
  }

  .loading{
    top: 4px;
    width: 128px;
    height: 128px;
    position: absolute;
    z-index: 2;
    background: rgba(255,255,255,.7);
    top:  1px;
    left: 1px;
    border-radius: 6px;
  }
  .image-box-info{
    display: inline-flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding: 8px;
  }
  .image-box-info.hidden-mode{
    background: rgba(30,30,30,.4);
    opacity: 0;
    border-radius: 8px;
    transition: opacity 0.3s ease;
  }
  .image-box-info.hidden-mode .button,
  .image-box-info.hidden-mode .span{
    color: #FFFFFF !important;
    border-color: #FFFFFF !important;
  }
  .image-box-info.hidden-mode:hover{
    opacity: .9;
  }

  .hidden-mode .span,
  .hidden-mode .button{
    color: #FFFFFF;
    border-color: #FFFFFF;
  }

  .sub-info{
    color: #576175;
    font-size: 10px;
    line-height: 16px;
    margin-bottom: 20px;
  }
  .warn-icon{
    align-items: center;
    background: #fdded8;
    border-radius: 20px;
    color: #f94346;
    display: inline-flex;
    flex-direction: row;
    font-size: 12px;
    font-weight: 400;
    justify-content: center;
    line-height: 18px;
    margin-left: 4px;
    padding: 1px 8px;
  }
  .loading-container{
    height: 128px;
    width: 128px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.8;
  }
  .load-icon-small{
      color: #00bcd4 !important;
      font-size: 50px !important;
      display: inline-block;
      line-height: 50px;
  }

  .icon-image-select-box-three{
    border: 1px solid rgba(0,0,0,.1);
    width: 130px;
    height: 240px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;
  }
  .icon-image-select-box-three .span{
    color: rgba(0, 0, 0, .4);
    font-size: 10px;
    font-weight: 600;
    line-height: 12px;
    text-align: center;
  }
  .icon-image-select-box-three .img{
    margin: -8px;
    width: 130px;
    height: 240px;
    position: absolute;
    z-index: -1;
  }
  .icon-image-select-box-three .button{
    align-items: center;
    border: 1px solid rgba(255,255,255, .9);
    border-radius: 6px;
    color: rgba(255,255,255, .9);
    cursor: pointer;
    display: inline-flex;
    flex-direction: column;
    font-size: 12px;
    font-weight: 600;
    height: unset;
    line-height: 14px;
    margin-bottom: 10px;
    padding: 2px 10px;
  }
  .icon-image-select-box-three .none-img-background{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.3);
    border-radius: 8px;
    z-index: -1;
  }
  .phone-type-select{
    margin: 30px -20px 0;
    padding-bottom: 10px;
    padding-left: 10px;
    border-bottom: 1px solid rgb(235, 236, 240);
    display: flex;
  }
  .phone-type-select>div{
    padding: 0 16px;
    color: rgba(0, 0, 0, 0.4);
    font-weight: 600;
    font-size: 14px;
    transition: color .3s ease;
    cursor: pointer;
    user-select: none;
  }
  .phone-type-select .selected{
    color: rgba(0,0,0,1);
  }
  .image-type-select {
    border-radius: 8px;
    background: rgba(0,0,0,0.05);
    height: 30px;
    margin: 16px 0px 0;
    display: flex;
  }
  .image-type-select div{
    border-radius: 6px;
    margin: 2px;
    line-height: 26px;
    flex: 1;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.5);
    background: rgba(255,255,255,0);
    text-align: center;
    transition: color,font-weight,background .5s ease;
    cursor: pointer;
    user-select: none;
  }
  .image-type-select .selected{
    font-weight: 600;
    color: rgba(0,0,0,1);
    background: rgba(255,255,255,1);
  }


  .setting-btn{
    position: absolute;
    right: 0;
    top: 0;
    background: rgba(50, 50, 50, .2);
    padding: 3px;
    border-radius: 7px;
    font-size: 16px !important;
    cursor: pointer;
  }
  .setting-btn:hover{
    background: rgb(50,50,50,.7);
  }
  .setting-btn:hover /deep/ .md-icon.md-theme-default.md-icon-font{
    color: #FFF;
  }
  .setting-btn-icon{
    font-size: 16px !important;
  }
  img{
    width: 100%;
    height: 100%;
  }
  .no-animate{
    transition: none !important;
  }
  .hide-label /deep/ label{
    opacity: 0 !important;
  }

  .image-name{
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    margin: 18px 0 12px;
  }
  .image-info{
    margin: 0px 0 12px;
    color: rgba(0,0,0,0.5);
    font-size: 10px;
    font-weight: 500;
  }
  .reset-icon{
    position: absolute;
    right: 2px;
    top: 2px;
    padding-left: 5px;
    padding-bottom: 5px;
    z-index: 1;
  }
  .reset-icon /deep/ .md-icon:hover{
    color: #000 !important;
  }
</style>